import { Form, Input, Button, Card, Typography, theme } from 'antd';
import { LoginOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';

import styles from '~/app/login/login.module.css';

const { Title, Text } = Typography;

type LoginFormCardProps = {
  title: string;
  intro: string;
  emailLabel: string;
  emailPlaceholder: string;
  emailRequired: string;
  emailInvalid: string;
  passwordLabel: string;
  passwordPlaceholder: string;
  passwordRequired: string;
  passwordMin: string;
  submitLabel: string;
  forgotLabel: string;
  isLoading: boolean;
  onSubmit: (values: {
    email: string;
    password: string;
  }) => void | Promise<void>;
};

export function LoginFormCard(props: LoginFormCardProps) {
  const {
    title,
    intro,
    emailLabel,
    emailPlaceholder,
    emailRequired,
    emailInvalid,
    passwordLabel,
    passwordPlaceholder,
    passwordRequired,
    passwordMin,
    submitLabel,
    forgotLabel,
    isLoading,
    onSubmit,
  } = props;

  const { token } = theme.useToken();

  return (
    <Card className={styles.card}>
      <div className={styles.header}>
        <Title level={3} className={styles.title}>
          {title}
        </Title>
        <Text type="secondary" className={styles.description}>
          {intro}
        </Text>
      </div>

      <Form
        layout="vertical"
        className={styles.form}
        onFinish={onSubmit}
        requiredMark={false}
      >
        <Form.Item
          label={emailLabel}
          name="email"
          rules={[
            { required: true, message: emailRequired },
            { type: 'email', message: emailInvalid },
          ]}
          validateTrigger={['onSubmit', 'onBlur']}
        >
          <Input
            size="large"
            disabled={isLoading}
            placeholder={emailPlaceholder}
            className={styles.loginField}
          />
        </Form.Item>

        <Form.Item
          label={passwordLabel}
          name="password"
          rules={[
            { required: true, message: passwordRequired },
            { min: 6, message: passwordMin },
          ]}
          validateTrigger={['onSubmit', 'onBlur']}
        >
          <Input.Password
            size="large"
            disabled={isLoading}
            placeholder={passwordPlaceholder}
            className={styles.loginField}
          />
        </Form.Item>

        <div className={styles.footer}>
          <Button
            block
            size="large"
            type="primary"
            htmlType="submit"
            loading={isLoading}
            icon={!isLoading ? <LoginOutlined /> : undefined}
            className={styles.submitButton}
          >
            {submitLabel}
          </Button>

          <Button
            type="link"
            size="small"
            className={styles.forgotLink}
            disabled={isLoading}
          >
            <Link to="/forgot-password" style={{ color: token.colorLink }}>
              {forgotLabel}
            </Link>
          </Button>
        </div>
      </Form>
    </Card>
  );
}
